var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseButton',{staticClass:"google-sign-in",attrs:{"id":"signin-button","name":"Zaloguj przez google"},nativeOn:{"click":function($event){return _vm.signIn($event)}}},[_vm._v("\n    Zaloguj przez google\n")])}
var staticRenderFns = []

export { render, staticRenderFns }